import _ from 'lodash'
import styled from '@emotion/styled'
import { L1TabularListText, L1TabularListTextCell } from "../../../form/l1/L1TabularList"
import { L2TabularListContentNoHeader, L2TabularListRoot } from "../../../form/l2/L2TabularList"
import { L2TabularListItemReadOnly } from "../../../form/l2/L2TabularListItem"
import { DashboardNotification, dateAndDow, s } from '@fusion-advantage/formlib'
import { V2L2WorkItemDetailContent, V2L2WorkItemDetailRoot, V2L2WorkItemDetailTitle } from './V2L2WorkItemDetail'
import { DateTime } from 'luxon'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faNote, faPerson } from '@fortawesome/pro-regular-svg-icons'
import L1PurifiedHtml from '../../../form/l1/L1PurifiedHtml'

const Content = styled(V2L2WorkItemDetailContent)({
	gridTemplateColumns: '1fr',
})

const NotificationsContainer = styled(L2TabularListContentNoHeader)`
	max-height: 18rem;
	overflow: auto;
`

interface L3TodayDetailProps {
	displayDate: string
	todoCount: number
	apptCount: number
	labCounts: Record<string, number>
	notifications: DashboardNotification[]
}

export const V2L3TodayDetail = ({todoCount, apptCount, labCounts, displayDate, notifications}: L3TodayDetailProps) => {
	return (
		<V2L2WorkItemDetailRoot>
			<V2L2WorkItemDetailTitle ready={true}>Summary for Today — {dateAndDow(DateTime.fromISO(displayDate))}</V2L2WorkItemDetailTitle>
			<Content>
				{ notifications && notifications.length > 0 &&
					<L2TabularListRoot gridTemplateColumns='max-content auto'>
						<NotificationsContainer>
							{
								notifications.map(n => (
									<DashboardNotificationRow key={n.Id} notification={n} />
								))
							}
						</NotificationsContainer>
					</L2TabularListRoot>
				}

				<L2TabularListRoot gridTemplateColumns="max-content 1fr">
					<L2TabularListContentNoHeader>
						{
							notifications.length > 0 && (
								<TodayDetailRow
									count={notifications.length}
									title={s('Notification', notifications.length)}
								/>
							)
						}
						<TodayDetailRow
							count={todoCount}
							title={s('TODO', todoCount)}
							description={(todoCount && apptCount) ? "Please complete these now before your appointments" : undefined}
						/>
						<TodayDetailRow count={apptCount} title={s('Appointment', apptCount)} />
						{_.map(labCounts, (count, name) => (
							<TodayDetailRow key={name} count={count} title={`${name}`} />
						))}
						{/* {_.keys(labCounts).length > 0 ? null : (
							<L2TabularListItemReadOnly>
								<L1TabularListTextCell centered color="negative"><Count>0</Count></L1TabularListTextCell>
								<L1TabularListTextCell color="negative"></L1TabularListTextCell>
							</L2TabularListItemReadOnly>
						)} */}
					</L2TabularListContentNoHeader>
				</L2TabularListRoot>
			</Content>
		</V2L2WorkItemDetailRoot>
	)
}

const Count = styled.div(({theme}) => ({
	paddingLeft: theme.spacing(1.5),
}))

interface TodayDetailRowProps {
	count: number
	title: string
	description?: string
}

interface DashboardNotificationRowProps {
	notification: DashboardNotification
}

const DashboardNotificationRow = ({notification}: DashboardNotificationRowProps) => {
	return (
		<L2TabularListItemReadOnly>
			<L1TabularListTextCell centered bold color="affirmative"><FontAwesomeIcon icon={notification.IsPersonal ? faPerson : faNote} /></L1TabularListTextCell>
			<L1TabularListTextCell><L1PurifiedHtml content={notification.Notification} /></L1TabularListTextCell>
		</L2TabularListItemReadOnly>
	)
}

const TodayDetailRow = ({count, title, description}: TodayDetailRowProps) => {
	if(count > 0) {
		return (
			<L2TabularListItemReadOnly>
				<L1TabularListTextCell centered bold color="affirmative"><Count>{count}</Count></L1TabularListTextCell>
				<L1TabularListTextCell>
					<L1TabularListText bold>{title}</L1TabularListText>
					{description ? <L1TabularListText color="negative">{description}</L1TabularListText> : null}
				</L1TabularListTextCell>
			</L2TabularListItemReadOnly>
		)
	}
	return (
		<L2TabularListItemReadOnly>
			<L1TabularListTextCell centered color="negative"><Count>0</Count></L1TabularListTextCell>
			<L1TabularListTextCell color="negative">{title}</L1TabularListTextCell>
		</L2TabularListItemReadOnly>
	)
}
